import Link from "next/link";

export const alreadyMinted = {
  title: "Our records show you’ve already minted an NFT.",
  description: (
    <>
      {" "}
      Not true? Email us at{" "}
      <a
        className="underline text-coinage-blue"
        href="mailto:contact@trustless.media">
        contact@trustless.media
      </a>
      . <br />
      <Link className="underline text-coinage-blue" href="/invitations">
        View Invites
      </Link>
    </>
  )
};
